import { Button, ButtonLink } from "@/components/Buttons/index";
import ProcessInformation from "@/components/ProcessInformation";
import config from "@/lib/config";
import { ADULT_RESTRICTION_AGE } from "@/lib/constants";
import routes from "@/lib/routes";
import processStyles from "@/styles/Process.module.scss";
import { useCallback } from "react";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export default function DisabledAccess() {
  var handleClick = useCallback(function () {
    window.location.href = routes.logout;
  }, []);
  return /*#__PURE__*/_jsx(ProcessInformation, {
    header: "\u30A2\u30AF\u30BB\u30B9\u3067\u304D\u307E\u305B\u3093",
    children: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("div", {
        className: processStyles.information,
        children: /*#__PURE__*/_jsxs("p", {
          children: ["\u3053\u306E\u5148\u306F\u30A2\u30C0\u30EB\u30C8\u30B3\u30F3\u30C6\u30F3\u30C4\u3067\u3059\u306E\u3067\u3001", ADULT_RESTRICTION_AGE, "\u6B73\u672A\u6E80\u306E\u65B9\u306E\u30A2\u30AF\u30BB\u30B9\u3092\u304A\u65AD\u308A\u3044\u305F\u3057\u307E\u3059\u3002"]
        })
      }), /*#__PURE__*/_jsxs("div", {
        className: processStyles.btnArea,
        children: [/*#__PURE__*/_jsx(ButtonLink, {
          type: "button",
          fillColor: true,
          large: true,
          fontFixed: true,
          href: config.host.vod,
          children: "SPOOX\u306B\u79FB\u52D5\u3059\u308B"
        }), /*#__PURE__*/_jsx(Button, {
          type: "button",
          fillColor: true,
          large: true,
          fontFixed: true,
          onClick: handleClick,
          children: "\u30ED\u30B0\u30A2\u30A6\u30C8\u3059\u308B"
        })]
      })]
    })
  });
}